var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showInstaller, "can-cancel": false, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showInstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _c("i", { staticClass: "fas fa-cube" }),
            _vm._v(" Instalación: Recibos de sueldo"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Configuración de parametros"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Carpeta de recibos"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button is-static is-fullwidth has-text-left",
                    },
                    [_vm._v(_vm._s(_vm.getRuta))]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("explorer", {
                ref: "listado",
                attrs: {
                  idFolder: _vm.settings.origen_id || _vm.organizacion.slug,
                  rutas: _vm.rutas,
                  selected: _vm.selected,
                },
                on: {
                  "update:rutas": function ($event) {
                    _vm.rutas = $event
                  },
                  "update:selected": function ($event) {
                    _vm.selected = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "help" }, [
                _vm._v("Elija la carpeta donde se guardaran los recibos."),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Flujo de firmas del empleado"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("div", { staticClass: "select" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.settings.firmaEmpleado,
                        expression: "settings.firmaEmpleado",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.settings,
                          "firmaEmpleado",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v("Sin firma"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v("Firma debil"),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v("Firma fuerte"),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Almacenes de software"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "path" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "path") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "path",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            En PC central\n          "),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "file" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "file") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "file",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            Certificado en archivo\n          "),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "mscapi" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "mscapi") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "mscapi",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            Almacen de Windows\n          "),
              ]),
              _vm._v(" "),
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.settings.almacenesSoft,
                      expression: "settings.almacenesSoft",
                    },
                  ],
                  attrs: { type: "checkbox", value: "backup" },
                  domProps: {
                    checked: Array.isArray(_vm.settings.almacenesSoft)
                      ? _vm._i(_vm.settings.almacenesSoft, "backup") > -1
                      : _vm.settings.almacenesSoft,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.settings.almacenesSoft,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "backup",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.settings,
                              "almacenesSoft",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.settings, "almacenesSoft", $$c)
                      }
                    },
                  },
                }),
                _vm._v("\n            Almacen en Signar\n          "),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("(Opcional) Directorio local de los certificados"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.pathCertificados,
                    expression: "settings.pathCertificados",
                  },
                ],
                staticClass: "input",
                class: { "is-danger": _vm.errors.has("path") },
                attrs: {
                  name: "path",
                  type: "text",
                  placeholder: "Ej: /ruta/de/certificados",
                },
                domProps: { value: _vm.settings.pathCertificados },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.settings,
                      "pathCertificados",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("(Opcional) Area de empleadores"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.areaEmpleadores,
                    expression: "settings.areaEmpleadores",
                  },
                ],
                staticClass: "input",
                attrs: { name: "area", type: "number" },
                domProps: { value: _vm.settings.areaEmpleadores },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.settings,
                      "areaEmpleadores",
                      $event.target.value
                    )
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Coordenadas de firma en conformidad"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorConf[0],
                          expression: "settings.coorConf[0]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorConf0") },
                      attrs: {
                        type: "text",
                        name: "coorConf0",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorConf[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorConf,
                            0,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorConf[1],
                          expression: "settings.coorConf[1]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorConf1") },
                      attrs: {
                        type: "text",
                        name: "coorConf1",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorConf[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorConf,
                            1,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorConf[2],
                          expression: "settings.coorConf[2]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorConf2") },
                      attrs: {
                        type: "text",
                        name: "coorConf2",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorConf[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorConf,
                            2,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorConf[3],
                          expression: "settings.coorConf[3]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorConf3") },
                      attrs: {
                        type: "text",
                        name: "coorConf3",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorConf[3] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorConf,
                            3,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Coordenadas de firma en disconformidad"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorDisc[0],
                          expression: "settings.coorDisc[0]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorDisc0") },
                      attrs: {
                        type: "text",
                        name: "coorDisc0",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorDisc[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorDisc,
                            0,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorDisc[1],
                          expression: "settings.coorDisc[1]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorDisc1") },
                      attrs: {
                        type: "text",
                        name: "coorDisc1",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorDisc[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorDisc,
                            1,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorDisc[2],
                          expression: "settings.coorDisc[2]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorDisc2") },
                      attrs: {
                        type: "text",
                        name: "coorDisc2",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorDisc[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorDisc,
                            2,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorDisc[3],
                          expression: "settings.coorDisc[3]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorDisc3") },
                      attrs: {
                        type: "text",
                        name: "coorDisc3",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorDisc[3] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorDisc,
                            3,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Coordenada empleador"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorEmpleador[0],
                          expression: "settings.coorEmpleador[0]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorEmpleador0") },
                      attrs: {
                        type: "text",
                        name: "coorEmpleador0",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorEmpleador[0] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorEmpleador,
                            0,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorEmpleador[1],
                          expression: "settings.coorEmpleador[1]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorEmpleador1") },
                      attrs: {
                        type: "text",
                        name: "coorEmpleador1",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorEmpleador[1] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorEmpleador,
                            1,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorEmpleador[2],
                          expression: "settings.coorEmpleador[2]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorEmpleador2") },
                      attrs: {
                        type: "text",
                        name: "coorEmpleador2",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorEmpleador[2] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorEmpleador,
                            2,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.number",
                          value: _vm.settings.coorEmpleador[3],
                          expression: "settings.coorEmpleador[3]",
                          modifiers: { number: true },
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "integer",
                          expression: "'integer'",
                        },
                      ],
                      staticClass: "input has-text-centered",
                      class: { "is-danger": _vm.errors.has("coorEmpleador3") },
                      attrs: {
                        type: "text",
                        name: "coorEmpleador3",
                        placeholder: "Número",
                      },
                      domProps: { value: _vm.settings.coorEmpleador[3] },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings.coorEmpleador,
                            3,
                            _vm._n($event.target.value)
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column is-8" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Patrón carga")]),
                _vm._v(" "),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.patron_carga,
                          expression: "settings.patron_carga",
                        },
                      ],
                      staticClass: "input",
                      class: { "is-danger": _vm.errors.has("patronCarga") },
                      attrs: { type: "text", name: "patronCarga" },
                      domProps: { value: _vm.settings.patron_carga },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings,
                            "patron_carga",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v(".pdf"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Patrón almacenamiento"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.settings.patron_almacenamiento,
                          expression: "settings.patron_almacenamiento",
                        },
                      ],
                      staticClass: "input",
                      class: {
                        "is-danger": _vm.errors.has("patronAlmacenamiento"),
                      },
                      attrs: { type: "text", name: "patronAlmacenamiento" },
                      domProps: { value: _vm.settings.patron_almacenamiento },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.settings,
                            "patron_almacenamiento",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-static" }, [
                      _vm._v(".pdf"),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "column content is-small" }, [
              _c("table", { staticClass: "table is-narrow" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Patrones disponibles"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("#d")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Día")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#m")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Mes")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#Y")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Año")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#uc")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("CUIT del empleado")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#ui")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("ID del empleado")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#rt")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Tipo de recibo")]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "notification is-primary" }, [
              _c("i", { staticClass: "fas fa-info-circle fa-fw" }),
              _vm._v(" Recuerde asignar los roles "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Empleador"),
              ]),
              _vm._v(" y "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Empleado"),
              ]),
              _vm._v(
                "  a los usuarios para que utilicen la funcionalidad.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("div", { staticClass: "buttons is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-dark is-outlined",
                  on: { click: _vm.cancelar },
                },
                [_vm._v("\n            Cancelar\n          ")]
              ),
              _vm._v(" "),
              _vm.params
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: _vm.errors.count() > 0 },
                      on: { click: _vm.reinstalar },
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: _vm.errors.count() > 0 },
                      on: { click: _vm.instalar },
                    },
                    [_vm._v("\n            Instalar módulo\n          ")]
                  ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }